<app-modal-window [title]="'Информация'"
                  [visible]="true"
                  [width]="600"
                  [height]="500"
                  [scrollbar]="true"
                  (close)="dialogRef.close()">

  <div class="container">
    <div class="container-body">
      <div class="info-row">
        <span class="info-label">Номер помещения</span>
        <span class="info-value">№{{ place.placeNumber ?? '-' }}</span>
      </div>
      <div class="info-row">
        <span class="info-label">Тип помещения</span>
        <span class="info-value">{{ place.roomTypeItemTitle || '-' }}</span>
      </div>
      <div class="info-row">
        <span class="info-label">Этаж</span>
        <span class="info-value">{{ data.floorNumber }}</span>
      </div>
      <div class="info-row">
        <span class="info-label">Подъезд</span>
        <span class="info-value">{{ place.entrance || '-' }}</span>
      </div>
      <div class="info-row">
        <span class="info-label">Площадь</span>
        <span class="info-value">{{ place.area ? (place.area | numberWithSpaces: 'twoDecimals') + ' м²' : '-' }}</span>
      </div>
      <div class="info-row">
        <span class="info-label">Статус</span>
        <span class="info-value" [class.sold]="isSold()">{{ isSold() ? 'Реализовано' : 'Не реализовано' }}</span>
      </div>
      <div class="info-row">
        <span class="info-label">Дата реализации</span>
        <span class="info-value">{{ place.saleDate ? (place.saleDate | date: 'dd.MM.yyyy') : '-' }}</span>
      </div>
      <div class="info-row">
        <span class="info-label">Сумма реализации</span>
        <span class="info-value">{{ place.saleAmount ? (place.saleAmount | numberWithSpaces: 'twoDecimals') + ' ₸' : '-' }}</span>
      </div>
      <div class="info-row">
        <span class="info-label">Цена</span>
        <span class="info-value">{{ place.priceAmount ? (place.priceAmount | numberWithSpaces: 'twoDecimals') + ' ₸' : '-' }}</span>
      </div>
    </div>
    <div class="container-footer">
      <button class="btn btn-cancel" type="button" mat-dialog-close>Закрыть</button>
    </div>
  </div>

</app-modal-window>
